<div class="board pr-3 pt-4 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div nz-row nzGutter="24">
    <div class="chart" nz-col nzSpan="18">
        <div nz-row nzGutter="24">
          <div nz-col nzSpan="12">
            <div nz-card-grid [ngStyle]="gridStyle">
              <nz-card [nzTitle]="templateTKNSTitle" nzType="inner">
                <div id="chartQuantityAge" style="height: 250px;"></div>
              </nz-card>
            </div>
          </div>
          <div nz-col nzSpan="12">
            <div nz-card-grid [ngStyle]="gridStyle" >
              <nz-card [nzTitle]="templateTTTitle" nzType="inner" >
                <div id="chartByTypeOfEducation" style="height: 250px;"></div>
              </nz-card>
            </div>
          </div>
          <div class="chartCarousel pt-4" nz-col nzSpan="12">
            <div nz-card-grid [ngStyle]="gridStyle" #cardContent>
              <nz-card [nzTitle]="templateTitleC1" nzType="inner">
                <div id="chartTypeOfDisbility" style="height: 250px;"></div>
              </nz-card>
            </div>
          </div>
          <div class="pt-4" nz-col nzSpan="12">
            <div nz-card-grid [ngStyle]="gridStyle" >
              <nz-card [nzTitle]="templateTLTitle" nzType="inner" >
                <div id="chartQTOfPersonnel" style="height: 250px;"></div>
              </nz-card>
            </div>
          </div>
        </div>
    </div>
    <div class="chart" nz-col nzSpan="6" class="pl-2">
      <div nz-card-grid [ngStyle]="gridStyle2" >
        <nz-card class="card" [nzTitle]="templateTBTitle" nzType="inner" [nzBodyStyle]="{padding: 0}">
          <div nz-row [nzGutter]="[24,12]" class="search-contact">
            <div nz-col nzSpan="24">
              <div nz-row [nzGutter]="[24,12]">
                <div nz-col nzSpan="20">
                  <asc-autocomplete [ascModel]="provinceControl" (ascModelChange)="changeProvince($event)"
                    placeholder="Chọn tỉnh thành..." [getListAC]="getProvinceACFn">
                  </asc-autocomplete>
                </div>
                <div nz-col nzSpan="4">
                </div>
                <div nz-col nzSpan="20">
                  <input nz-input placeholder="Nhập tên cơ sở" [(ngModel)]="commonFilter.SearchTerm" />
                </div>
                <div class="nonpadding-y" nz-col nzSpan="4">
                  <button nz-button class="btn-search flex items-center justify-center mt-1" [nzType]="'primary'"
                    nzTooltipTitle="Tìm kiếm"
                    nzTooltipPlacement="bottom"
                    (click)="search()"
                    nz-tooltip><i nz-icon nzType="search" nzTheme="outline"></i></button>
                </div>
              </div>
            </div>
          </div>
          <div class="overflow-auto list">
            <ng-container *ngFor="let item of lstthongtin">
              <nz-card [nzLoading]="isloading" >
                <div class="school" nz-tooltip [nzTooltipTitle]="item.educationAndTrainingName">
                  <label><b>Cơ sở:</b></label>
                  <span>&nbsp;{{item.educationAndTrainingName}}</span>
                </div>
                <div class="flex">
                  <div class="avatar-contact">
                    <img [src]="'assets/avatar.svg'" style="width:40px">
                  </div>
                  <div class="list-contact">
                      <div *ngIf="item.director">
                          <label><b>Lãnh đạo:</b></label>
                          <span>&nbsp;{{item.director}}</span>
                      </div>
                      <div *ngIf="item.directorPhoneNumber">
                          <label><b>SĐT:</b></label>
                          <span>&nbsp;{{item.directorPhoneNumber}}</span>
                      </div>
                  </div>
                </div>
              </nz-card>
            </ng-container>
          </div>
        </nz-card>
      </div>
    </div>
  </div>
</div>
<ng-template #templateTitleC1>
  <span nz-tooltip [nzTooltipTitle]="titleTypeOfDisbility ? (titleTypeOfDisbility + ' ' + (TotalTypeOfDisbility | number)) : ''" >
    <i nz-icon nzType="team"></i>
    {{ titleTypeOfDisbility ? (titleTypeOfDisbility + ' ' + (TotalTypeOfDisbility | number)) : '' }}
  </span>
</ng-template>
<ng-template #templateTitleC2>
  <div class="w-full flex justify-between">
    <div>
      <i nz-icon style="float: left; margin-top: 5px;" nzType="left" (click)="pre(2)"></i>
    </div>
    <div class="title-card" nz-tooltip [nzTooltipTitle]="'Chúc mừng sinh nhật ('+dobC2+')'">
      Chúc mừng sinh nhật&nbsp;({{ dobC2 }})
    </div>
    <div>
      <i nz-icon style="float: right; margin-top: 5px;" nzType="right" (click)="next(2)"></i>
    </div>
  </div>
</ng-template>
<ng-template #templateTKNSTitle>
  <span nz-tooltip [nzTooltipTitle]="titleAgeStudent ? (titleAgeStudent + ' ' + (TotalAge | number)) : '' ">
    <i nz-icon nzType="team"></i>
    {{ titleAgeStudent ? (titleAgeStudent + ' ' + (TotalAge | number)) : '' }}
  </span>
</ng-template>
<ng-template #templateTTTitle>
  <span nz-tooltip [nzTooltipTitle]="titleTypeOfEducation ? (titleTypeOfEducation + ' ' + (TypeOfEducation | number)): '' ">
    <i nz-icon nzType="team"></i>
    {{ titleTypeOfEducation ? (titleTypeOfEducation + ' ' + (TypeOfEducation | number)): '' }}
  </span>

</ng-template>
<ng-template #templateTLTitle>
  <span nz-tooltip [nzTooltipTitle]="titleQTOfPersonnel ? (titleQTOfPersonnel + ' ' +  (TypeOfPersonnel | number)) : '' ">
    <i nz-icon nzType="team"></i>
    {{ titleQTOfPersonnel ? (titleQTOfPersonnel + ' ' +  (TypeOfPersonnel | number)) : ''}}
  </span>
</ng-template>
<ng-template #templateTHSTitle>
  <i nz-icon nzType="team"></i>
  <span nz-tooltip nzTooltipTitle="Tổng học sinh:&nbsp;2000">
    Tổng học sinh:&nbsp;2000
  </span>
</ng-template>
<ng-template #templateTBTitle>
  <span nz-tooltip [nzTooltipTitle]="'THÔNG TIN LIÊN LẠC'">
    <i nz-icon nzType="contacts" nzTheme="outline"></i>
    THÔNG TIN LIÊN LẠC
  </span>
</ng-template>
<ng-template #avatarTemplate>
  <nz-avatar nzSrc="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"></nz-avatar>
</ng-template>
